import { render, staticRenderFns } from "./cableGoodsCard.vue?vue&type=template&id=25a6fd5d&scoped=true"
import script from "./cableGoodsCard.vue?vue&type=script&lang=js"
export * from "./cableGoodsCard.vue?vue&type=script&lang=js"
import style0 from "./cableGoodsCard.vue?vue&type=style&index=0&id=25a6fd5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a6fd5d",
  null
  
)

export default component.exports